<script setup lang="ts">
import LeTooltip from "@dsk/components/LeTooltip.vue";
import { computed } from "vue";

import type { DictsysInflections, DictsysInflectionsByForm } from "@/types";

const props = defineProps<{
  inflections: DictsysInflections;
  usageLanguage: string;
  targetLanguage: string;
}>();

const shortOrText = computed<string>(() => (props.usageLanguage === "de" ? "oder" : "el."));

const screenReaderText = (inflectionObject: DictsysInflectionsByForm): string => {
  const or = props.usageLanguage === "de" ? "oder" : "eller";

  let text = "";

  if (inflectionObject.form !== null) {
    text += `${inflectionObject.form}: `;
  }

  return text + inflectionObject.long.join(` ${or} `);
};
</script>

<template>
  <span v-if="props.inflections.byForm.length > 0" class="le-article-inflections"
    ><template v-for="(inflectionObject, outerIndex) in props.inflections.byForm" :key="outerIndex"
      ><LeTooltip :text="inflectionObject.form ?? ''" :margin-bottom="8" aria-hidden="true"
        ><span v-if="outerIndex === 0">&lt;</span
        ><template v-for="(shortInflection, innerIndex) in inflectionObject.short" :key="innerIndex"
          ><span :lang="props.targetLanguage">{{ shortInflection }}</span
          ><span v-if="innerIndex < inflectionObject.short.length - 1">
            <i class="le-article-inflections__separation-element" :lang="props.usageLanguage">
              {{ shortOrText }}
            </i>
          </span></template
        ><template v-if="outerIndex === props.inflections.byForm.length - 1">&gt;</template></LeTooltip
      ><span v-if="outerIndex < props.inflections.byForm.length - 1" aria-hidden="true">, </span>
      <div class="sr-only">
        {{ screenReaderText(inflectionObject) }}
      </div></template
    ></span
  >
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
@import "@/assets/styles/dictsys-article";

.le-article-inflections {
  color: @colors[@neutrals][300];
  .dictsys-article-text();

  &__separation-element {
    margin-right: 5px;
    margin-left: 5px;
  }
}
</style>
